export const MY_SAVED_CARDS_LOCALE_TEXT = {
  'my_saved_payment_cards.card_title': {
    'en-GB': 'My Saved Payment Cards',
    'nl-NL': 'Mijn opgeslagen betaalkaarten',
  },
  'my_saved_payment_cards.page_title': {
    'en-GB': 'Saved Cards | Moonpig',
    'nl-NL': 'Opgeslagen betaalmethodes | Greetz',
  },
  'my_saved_payment_cards.heading_title': {
    'en-GB': 'Saved Payment Methods',
    'nl-NL': 'Opgeslagen betaalmethodes',
  },
  'my_saved_payment_cards.page_subtitle': {
    'en-GB':
      'The following payment methods are associated with your account. Any changes you make will not affect orders you have already placed.',
    'nl-NL':
      'De volgende betaalmethodes zijn gekoppeld aan jouw account. Wanneer je iets aanpast, heeft dat geen invloed op de bestellingen die je al geplaatst hebt,',
  },
  'my_saved_payment_cards.error.loading': {
    'en-GB':
      'There was a problem loading your saved payment methods. Please reload the page to try again.',
    'nl-NL':
      'Er ging iets fout bij het laden van je opgeslagen betaalmethodes. Laad de pagina opnieuw en probeer het nogmaals.',
  },
  'my_saved_payment_cards.error.no_cards': {
    'en-GB': 'You do not have any payment cards associated with this account.',
    'nl-NL': 'Er zijn geen betaalmethodes gekoppeld aan je MyGreetz-account.',
  },
  'my_saved_payment_cards.back_to_my_account': {
    'en-GB': 'Back to My Account',
    'nl-NL': 'Terug naar MyGreetz',
  },
  'my_saved_payment_cards.error_unknown': {
    'en-GB': "Oops! Something's not quite right",
    'nl-NL': 'Oeps! Er klopt iets niet',
  },
  'my_saved_payment_cards.has_membership': {
    'en-GB': 'This card is used for Moonpig Plus.',
  },
  'my_saved_payment_cards.manage_membership': {
    'en-GB': 'Manage Moonpig Plus',
  },
}
